/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import UiBookingPriceTablesBaseComponent from 'uplisting-frontend/components/ui/booking/price/tables/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class UiBookingPriceTablesPendingItemsComponent extends UiBookingPriceTablesBaseComponent {
  @cached
  get chargesWithId(): ModelRegistry['additional-booking-charge'][] {
    return this.booking.pendingAdditionalCharges.filter((charge) => charge.id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Price::Tables::PendingItems': typeof UiBookingPriceTablesPendingItemsComponent;
  }
}
